import { style } from 'typestyle'
export const ml8 = style({ marginLeft: '8px' })
